import React from "react";
import { motion } from "framer-motion";
import { FlameIcon, GlobeIcon } from "lucide-react";
type ScarcityBarProps = {
  dark?: boolean;
};
export function ScarcityBar({
  dark = false
}: ScarcityBarProps) {
  return <div className="mt-6" data-id="element-54" data-mp="2l3v5gw82woal">
      <div className={`rounded-2xl border p-4 ${dark ? "border-white/15 bg-white/5" : "border-alert/20 bg-red-50"}`} data-id="element-55" data-mp="2l4o397p283gl">
        <div className="flex items-center justify-between gap-3" data-id="element-56" data-mp="2b6gydn81pbuy">
          <p className={`flex items-center gap-1.5 text-sm font-bold ${dark ? "text-white" : "text-navy"}`} data-id="element-57" data-mp="2b9321brtf77w">
            <FlameIcon className="h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-58" data-mp="226bqlbyxwbg9" />
            Only <span className="text-alert" data-id="element-59" data-mp="27555n8tvkaij">9 spots</span> left at the promotional price
          </p>
          <span className="shrink-0 text-xs font-black text-alert" data-id="element-60" data-mp="276zpejtetwl1">91% CLAIMED</span>
        </div>
        <div className={`mt-3 h-4 overflow-hidden rounded-full ${dark ? "bg-white/15" : "bg-red-100"}`} role="progressbar" aria-valuenow={91} aria-valuemin={0} aria-valuemax={100} aria-label="91% of promotional spots claimed" data-id="element-61" data-mp="cuik76wd8kz">
          <motion.div className="h-full rounded-full bg-alert" initial={{
          width: "60%"
        }} whileInView={{
          width: "91%"
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-62" data-mp="2zjgoznn6ikpn" />
        </div>
      </div>
      <p className={`mt-3 flex items-start justify-center gap-1.5 text-center text-xs leading-relaxed ${dark ? "text-white/70" : "text-navy/60"}`} data-id="element-63" data-mp="2kptz8r9qowy3">
        <GlobeIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-64" data-mp="2uk3seb6i9z9v" />
        Price in USD. Your local currency is converted automatically at checkout.
      </p>
    </div>;
}